<div class="assessment-info-card" appBlockCopyPaste>
    <!-- User Info Section (Top) -->
    <div class="user-section">
        <div class="s-name">{{getShortName(assessmentInfo?.candidateName)}}</div>
        <div class="user-details">
            <div class="user-name">{{assessmentInfo?.candidateName}}</div>
            <div class="user-email">{{assessmentInfo?.email}}</div>
        </div>
    </div>

    <!-- Assessment Details Section (Bottom) -->
    <div class="details-section">
        <div class="detail-item">
            <div class="label">ASSESSMENT NAME</div>
            <div class="value">{{assessmentInfo?.name}}</div>
        </div>
        <div class="detail-item">
            <div class="label">DURATION</div>
            <div class="value">{{assessmentInfo?.duration}} {{assessmentInfo?.duration === 1 ? 'min' : 'mins'}}</div>
        </div>
        <div class="detail-item" *ngIf="assessmentInfo?.progress !== undefined">
            <div class="label">PROGRESS</div>
            <div class="progress-wrapper" style="min-width: 140px;">
                <mat-progress-bar mode="determinate" [value]="assessmentInfo?.progress"
                    class="custom-progress"></mat-progress-bar>
                <div class="progress-text">{{assessmentInfo?.progress | number:'1.0-0'}}% Complete</div>
            </div>
        </div>
        <div class="detail-item">
            <a class="our-terms-label" [routerLink]="['/terms-and-conditions']" target="_blank" rel="noopener">Our
                Terms</a>
        </div>
    </div>
</div>